import Lottie from 'react-lottie';
import animationData from '@assets/lottie-files/question';

const LottieFile = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="relative">
      <div className="absolute w-full h-full  z-10"></div>
      <Lottie
        id={'tenthLottie'}
        options={defaultOptions}
        height={400}
        width={400}
        speed={1}
      />
    </div>
  );
};

export default LottieFile;
